import React from 'react'

const SwitchToggle = ({checked,onChange,name}) => {
  return (
    <label className="checkbox-toggle">
        <input className="checkbox-toggle-checkbox" checked={checked} onChange={onChange} name={name} type="checkbox" />
        <div className="checkbox-toggle-switch"/>
    </label>
  )
}

export default SwitchToggle